export default "__VITE_ASSET__DlvulGMQ__"